export const TEST_ID = 'chemicalDetailFields';
